var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isNew
    ? _c("span", { staticClass: "sale-badge sale-red" }, [_vm._v("\n  NEU\n")])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }